import { render, staticRenderFns } from "./ShiftSegmentTypeTag.vue?vue&type=template&id=75185881&"
import script from "./ShiftSegmentTypeTag.vue?vue&type=script&lang=js&"
export * from "./ShiftSegmentTypeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports